import {
  ActivePeriodErrorStateType,
  CustomerEligibilityOptions,
  CustomerEligibilityStateType,
  RtoRiskStrategyOptions,
  utmDataOptions
} from 'src/lib/types/common/customerConditions'

export const initialCustomerEligibilityState: CustomerEligibilityStateType = {
  type: CustomerEligibilityOptions.ALL_CUSTOMERS
}

export const activePeriodDefaultErrorState: ActivePeriodErrorStateType = {
  startDate: {
    status: false,
    message: ''
  },
  endDate: {
    status: false,
    message: ''
  }
}

export const utmDataDropdownOptions = [
  {
    label: 'UTM Source',
    value: utmDataOptions.UTM_SOURCE
  },
  {
    label: 'UTM Campaign',
    value: utmDataOptions.UTM_CAMPAIGN
  },
  {
    label: 'UTM Medium',
    value: utmDataOptions.UTM_MEDIUM
  },
  {
    label: 'UTM Content',
    value: utmDataOptions.UTM_CONTENT
  }
]

export const rtoRiskDropdownOptions = [
  {
    label: 'Greater than or equal to',
    value: RtoRiskStrategyOptions.GREATER_THAN
  },
  {
    label: 'Less than or equal to',
    value: RtoRiskStrategyOptions.LESS_THAN
  }
]
